import React, { useState } from 'react'
import PropTypes from 'prop-types'
import isEmpty from 'lodash/isEmpty'
// @material-ui
import { Grid } from '@material-ui/core'
import { withStyles } from '@material-ui/styles'

// core
import { useGlobal } from '_core/hooks/useGlobal'
import { BannersList } from '_core/views/BannersList'

// style
import { bannersStyle } from './bannersStyle'

const RawBanners = props => {
  const {
    rowLg,
    rowMd,
    rowSm,
    rowXs,
    classes,
    customColumns,
  } = props

  const {
    config: { ROUTE_URL, ARTICLE_KEY },
  } = useGlobal()

  const inRowLg = rowLg || 2
  const inRowMd = rowMd || 2
  const inRowSm = rowSm || 2
  const inRowXs = rowXs || 1

  const defaultColumns = [
    {
      path: ARTICLE_KEY.BANNERS,
      url: ROUTE_URL.BANNERS,
    },
  ]

  const columns = !isEmpty(customColumns) ? customColumns : defaultColumns

  const [isActive, setIsActive] = useState(columns.map(() => true))
  

  const getOnUpdate = index => data => {
    setIsActive(list => {
      const newVal =
        data != null && Array.isArray(data.list) && data.list.length > 0

      if (list[index] === newVal) {
        return list
      }

      return list.map((val, i) => (i === index ? newVal : val))
    })
  }

  const renderColumn = (item, index) => (
    <Grid key={index} item={true} xs={12} className={classes.column}>

      <BannersList
        path={item.path}
        baseUrl={item.url}
        renderEmpty={() => null}
        renderFailure={() => null}
        hasPaging={false}
        onUpdate={getOnUpdate(index)}
        inRowLg={inRowLg}
        inRowMd={inRowMd}
        inRowSm={inRowSm}
        inRowXs={inRowXs}
      />

    </Grid>
  )

  return (
    <Grid container={true} className={classes.root}>
      {columns.map((data, index) =>
        isActive[index] ? renderColumn(data, index) : null
      )}
    </Grid>
  )
}

RawBanners.defaultProps = {}

RawBanners.propTypes = {
  // `withStyles` HOC props
  classes: PropTypes.object.isRequired,

  // 
  rowLg: PropTypes.number,
  rowMd: PropTypes.number,
  rowSm: PropTypes.number,
  rowXs: PropTypes.number,
}

export const Banners = withStyles(bannersStyle)(RawBanners)
